@if (isBusy) {
    <ws-ace-loader [hideLabel]="false" label="Saving changes"></ws-ace-loader>
}

<ws-modal-wrapper headerLabel="Forms"
                  subHeaderLabel="Check the forms you wish to add to returns and uncheck the ones you wish to remove."
                  (save)="save()"
                  (cancel)="cancel()"
                  [disableSave]="disableSave()"
                  [acceptHelpContentId]="acceptHelpText">
    <div class="ws-flex-container-horizontal ws-flex-align-items-center mb-3">
        <div class="ws-flex-none">Apply changes to:</div>
        <div class="ws-flex-none" style="padding-left: 8px;">
            <select class="form-select form-select-sm"
                    [disabled]="applyChangesScopeOptions.length === 1"
                    [(ngModel)]="selectedApplyChangesScopeOption"
                    (change)="onSelectedApplyChangesScopeFilterChange()">
                @for (item of applyChangesScopeOptions; track item) {
                    <option [ngValue]="item">{{ item.value }}</option>
                }
            </select>
        </div>
    </div>

    <table class="table table-condensed">
        <tbody>
            @for (item of formRevisionAssociations; track item) {
                <tr>
                    <td class="col-lg-1">
                        <label class="small">
                            <input type="checkbox"
                                   [ngModel]="item.isSelected"
                                   (ngModelChange)="onFormSelectedChange(item)">
                        </label>
                    </td>
                    <td class="col-lg-3">{{ item.formRevisionDisplayName }}</td>
                    <td class="col-lg-7"
                        [ngClass]="{ 'text-success': item.hasChanges && item.isSelected === true, 'text-danger': item.hasChanges && (!item.isSelected || (!item.isPrimary && item.isPrimary !== item.isPrimaryInitial)) }">
                        {{ getMessage(item) }}
                    </td>
                    <td class="col-lg-1">
                        @if (item.isSelected) {
                            <span class="primary-form clickable"
                                  helpTooltip
                                  helpContentId="return-preview-form-list.set-primary"
                                  (click)="setFormPrimary(item)">
                                @if (item.isPrimary && !item.parentFormRevisionId) {
                                    <i class="fa fa-star"></i>
                                } @else if (!item.parentFormRevisionId) {
                                    <i class="fa fa-regular fa-star"></i>
                                }
                            </span>
                        }
                    </td>
                </tr>
            }
        </tbody>
    </table>
</ws-modal-wrapper>
